<template>

    <div class="product">
        <inertia-link
            :href="href"
        >
            <div>
                <img
                    v-if="product.mainimage"
                    :src="product.mainimage.url"
                    :alt="product.mainimage.name"
                />
                <img
                    v-else
                    :src="require('../../../sass/sustainableclothing/img/no-product-image.jpg').default"
                    :alt="product.name"
                />
                <span v-if="product.new === true" class="new-icon">NEW</span>
            </div>

            <h3>
                {{ product.name }}
            </h3>
            <p v-if="isAuthenticated">
                {{ product.min_price | toCurrency }}
                <span v-if="product.min_price !== product.price">
                    &ndash; {{ product.price | toCurrency }}
                </span>
            </p>
        </inertia-link>
    </div>

</template>

<script>

export default {

    computed: {
        href() {
            return this.route('products.item', {brand_slug:this.product.brand_slug, slug: this.product.slug});
        },
        isAuthenticated() {
            return !!this.$page.props.auth.email;
        },
    },

    name:'ComponentsProductsOverviewItem',

    props: {
        product: {
            required:true,
        },
    },

}

</script>
